import { Flex, media } from '@hg/stylizator/utils'
import * as React from 'react'
import styled from 'styled-components'

import { IAttributes } from './Attributes'

const TwoSidedLayoutBlockComponent: React.FC<React.PropsWithChildren<IAttributes>> = (props) => (
  <Wrapper {...props}>
    <Layout>{props.children}</Layout>
  </Wrapper>
)

const Wrapper = styled.div<IAttributes>`
  @media ${media.largeDesktop} {
    padding: ${(props) => props.largeDesktopMargin}px;
  }
  @media ${media.desktop} {
    padding: ${(props) => props.desktopMargin}px;
  }
  @media ${media.tablet} {
    padding: ${(props) => props.tabletMargin}px;
  }
  @media ${media.mobile} {
    padding: ${(props) => props.mobileMargin}px;
  }
`

const Layout = styled(Flex)`
  justify-content: space-between;
  width: 100%;
  align-items: center;
`

export default TwoSidedLayoutBlockComponent
